export const PATH_PUBLIC_IMAGES = {
	img_homepage_1: "/images/homepage/homepage_1.png",
	home_utilities_1: "/images/homepage/home_utilities_1.png",
	home_utilities_2: "/images/homepage/home_utilities_2.png",
	home_utilities_3: "/images/homepage/home_utilities_3.png",
	home_contact_bg: "/images/homepage/contact_bg.png",
	img_faqs: "/images/faqs.png",
	// contact
	contact_image_1: "/images/contact-us/contact-us-1.png",
	contact_image_2: "/images/contact-us/contact-us-2.png",
	contact_image_3: "/images/contact-us/contact-us-3.png",
	// service - private jet
	private_jet_travel_hero_image: "/images/private-jet-travel/private-jet-travel-hero-image.png",
	private_jet_travel_1: "/images/private-jet-travel/private-jet-travel-1.png",
	private_jet_travel_2: "/images/private-jet-travel/private-jet-travel-2.png",
	private_jet_travel_3: "/images/private-jet-travel/private-jet-travel-3.png",
	private_jet_travel_4: "/images/private-jet-travel/private-jet-travel-4.png",
	private_jet_travel_5: "/images/private-jet-travel/private-jet-travel-5.png",
	private_jet_travel_bg_left: "/images/private-jet-travel/private-jet-travel-bg-left.png",
	private_jet_travel_bg_right: "/images/private-jet-travel/private-jet-travel-bg-right.png",
	img_services_private_jet: "/images/services/service-private-jet.png",
	img_services_air_freight: "/images/services/service-air-freight.png",
	img_services_jet_one_suites: "/images/services/service-jet-one-suites.png",
	// service - air freight
	service_af_background: "/images/services/air-freight/air-freight-background.png",
	service_af_area_of_operation: "/images/services/air-freight/air-freight-area-of-operation.png",
	service_af_experience: "/images/services/air-freight/air-freight-experience.png",
	service_af_mask: "/images/services/air-freight/air-freight-mask.png",
	service_af_freight_1: "/images/services/air-freight/royal-air-freight-1.png",
	service_af_freight_2: "/images/services/air-freight/royal-air-freight-2.png",
	// service - jet 1 suites
	service_j1s_background: "/images/services/jet-one-suites/jet-1-suites-background.png",
	service_j1s_provision_luxury_1: "/images/services/jet-one-suites/jet-1-suites-provision-luxury-1.png",
	service_j1s_provision_luxury_2: "/images/services/jet-one-suites/jet-1-suites-provision-luxury-2.png",
	service_j1s_provision_luxury_3: "/images/services/jet-one-suites/jet-1-suites-provision-luxury-3.png",
	service_j1s_provision_luxury_4: "/images/services/jet-one-suites/jet-1-suites-provision-luxury-4.png",
	// journey
	journey_background: "/images/journey/journey-background.png",
	journey_available_positions: "/images/journey/journey-available-positions.png",
	journey_company_at_glance: "/images/journey/journey-company-at-glance.png",
	journey_join_team: "/images/journey/journey-join-team.png",
	journey_mask_timeline: "/images/journey/journey-mask-timeline.png",
	journey_commitment_1: "/images/journey/journey-commitment-1.png",
	journey_commitment_2: "/images/journey/journey-commitment-2.png",
	journey_commitment_3: "/images/journey/journey-commitment-3.png",
	journey_commitment_4: "/images/journey/journey-commitment-4.png",
	// welcome
	img_jos_welcome_1: "/images/services/jos-welcome-1.png",
	img_jos_welcome_2: "/images/services/jos-welcome-2.png",
	img_jos_welcome_3: "/images/services/jos-welcome-3.png",
	logo: "/images/logo.svg",
	icon_aircraft_detail_backpack: "/images/aircraft-detail/backpack.png",
	icon_aircraft_detail_golf: "/images/aircraft-detail/golf.png",
	icon_aircraft_detail_roller_bag: "/images/aircraft-detail/large_roller_bags.png",
	icon_aircraft_detail_skiing: "/images/aircraft-detail/skiing.png",
};
